import React from 'react';
import { useStateSelector } from 'src/redux';

interface Props {}

export const IconVariableAssessment: React.FC<Props> = () => {
  const colors = useStateSelector((state) => state.theme.colors);
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
      <path
        d="M5.00098 4.13477C5.14528 4.13477 5.2627 4.25218 5.2627 4.39648V5.49512H7.94238C8.10461 5.49537 8.23633 5.62678 8.23633 5.78906V7.25977H9.70605C9.86849 7.25977 10 7.39127 10 7.55371V10.4951C9.99988 10.6574 9.86841 10.7891 9.70605 10.7891H6.17676C6.0144 10.7891 5.88294 10.6574 5.88281 10.4951V7.55371C5.88281 7.39127 6.01432 7.25977 6.17676 7.25977H7.64746V6.08301H2.35352V7.25977H3.82324C3.98568 7.25977 4.11719 7.39127 4.11719 7.55371V10.4951C4.11706 10.6574 3.9856 10.7891 3.82324 10.7891H0.293945C0.131585 10.7891 0.000124117 10.6574 0 10.4951V7.55371C0 7.39127 0.131509 7.25977 0.293945 7.25977H1.76562V5.78906C1.76562 5.62663 1.89713 5.49512 2.05957 5.49512H4.73926V4.39648C4.73926 4.25218 4.85668 4.13477 5.00098 4.13477ZM0.587891 10.2012H3.5293V7.84766H0.587891V10.2012ZM6.4707 10.2012H9.41211V7.84766H6.4707V10.2012ZM6.66309 3.78906H6.1377L5.83203 2.94141H4.16895L3.86328 3.78906H3.33789L4.71582 0H5.29004L6.66309 3.78906ZM4.31152 2.53711H5.68945L5 0.612305L4.31152 2.53711Z"
        fill={colors.brightBlue}
      />
    </svg>
  );
};
